export default __webpack_public_path__ + "static/media/330_dummy2016-architekturbuero01-de.88125cc9.png";